module.exports = __webpack_public_path__ + "img/layout-icon.aeb2c37b.svg";